import React from 'react';
import { useLocation } from 'react-router';
import { Route, Redirect } from 'react-router-dom';
import { useAuthUserQuery } from '@queries';
import { setBrowserStorageItem } from '@utils/browserStorage';
import { UserProvider } from '@context/user';
import { PAGE_URLS, BROWSER_STORAGE_KEYS } from '@constants';

// A customized Route component that redirects if the user hasn't authenticated via Azure Apps
export function PrivateRoute ({ adminRoute = false, children, ...rest }) {
    const { search } = useLocation();
    const { queryParamsKey } = BROWSER_STORAGE_KEYS;
    const { AUTHORIZE, NOT_AUTHORIZED } = PAGE_URLS;
    const { isLoading, error, data: user } = useAuthUserQuery();
  
    if (isLoading) return <div>Loading...</div>;
  
    if (error) {
        if (error.response?.status === 401) {
            if (search) {
                setBrowserStorageItem(queryParamsKey, search, sessionStorage);
            }
            
            return <Redirect to={AUTHORIZE} />;
        } 
  
        return (
          <div style={{color: 'red'}}>
              <p>There&apos;s a problem - please refresh the page.</p>
          </div>
        );
    }
  
    function RedirectIfUnauthorized({ user, adminRoute }) {
        if (adminRoute && user.profile !== 'Admin') {
            return <Redirect to={NOT_AUTHORIZED} />;
        }
  
        return (
          <UserProvider user={user}>
              {children}
          </UserProvider>
        );
    }
  
    return (
        <Route {...rest} render={() => RedirectIfUnauthorized({ user, adminRoute })} /> 
    );
}

export default PrivateRoute;
